export default __webpack_public_path__ + "static/treneri-marek-polacek-4da50ca0fa398875ea384f91b7f1d71d.jpg";